import type { EconomicsIndicator } from "./api";

const unitLabels:Record<string,string>={
  percent:"%",
  index:"index points",
  thousands:"thousand",
  count:"claims",
  "billions chained dollars":"billion chained dollars",
  "thousands annualized":"thousand annualized",
  "millions dollars":"million dollars",
};

export function formatIndicatorValue(item?:EconomicsIndicator):string{
  if(!item||item.value==null)return "—";
  const value=item.value.toLocaleString(undefined,{maximumFractionDigits:2});
  if(item.unit==="percent")return `${value}%`;
  if(item.unit==="billions chained dollars")return `$${value}B`;
  if(item.unit==="millions dollars")return `$${value}M`;
  if(item.unit==="thousands"||item.unit==="thousands annualized")return `${value}K`;
  return value;
}

export function formatUnit(unit:string):string{return unitLabels[unit]||unit.replaceAll("-"," ")}

export function formatChange(value:number|null|undefined,unit:string):string{
  if(value==null)return "—";
  const sign=value>0?"+":"";
  const formatted=Math.abs(value)>=100?value.toLocaleString(undefined,{maximumFractionDigits:0}):value.toLocaleString(undefined,{maximumFractionDigits:2});
  if(unit==="percentage-points")return `${sign}${formatted} pp`;
  if(unit==="percent")return `${sign}${formatted}%`;
  return `${sign}${formatted} ${formatUnit(unit)}`;
}

export function latestChange(item:EconomicsIndicator):{text:string;date:string|null}{
  const change=item.changes?.latest;
  return {text:formatChange(change?.value??item.latestChange,change?.unit||fallbackLatestUnit(item)),date:change?.comparisonDate||null};
}

export function yearOverYearChange(item:EconomicsIndicator):{text:string;date:string|null}{
  const change=item.changes?.yearOverYear;
  return {text:formatChange(change?.value??item.yearOverYearChange,change?.unit||"percent"),date:change?.comparisonDate||null};
}

function fallbackLatestUnit(item:EconomicsIndicator):string{
  if(item.unit==="percent")return "percentage-points";
  if(["index","count","billions chained dollars","thousands annualized","millions dollars"].includes(item.unit))return "percent";
  return item.unit;
}

export function formatTimestamp(value:string|null|undefined):string{
  if(!value)return "Unavailable";
  return new Date(value).toLocaleString();
}

export function formatDate(value:string|null|undefined):string{
  if(!value)return "Unavailable";
  const normalized=value.length===10?`${value}T12:00:00Z`:value;
  return new Date(normalized).toLocaleDateString(undefined,{year:"numeric",month:"short",day:"numeric"});
}
